/* THE REMEMBERED SIZE (Andre, 2026-10-19: "if someone uses the size chart and they hit Select, it will
   apply it to their session on the website. Every product page they go to will already be selected in
   that size").

   SAVED from two places: a Select in the PDP size drawer ([data-size-pick], the chart row or the "use
   your current shoes" answer card), and the Select on the size guide page's answer card
   ([data-size-save], added by assets/pulse-size-reco.js). APPLIED on every product page that renders
   the size drawer, by setting the size <select> exactly as the drawer's own Select does.

   TWO RANGES, ONE FOOT. The original range (Flow, Bianco) and the current range have different charts,
   so the same number does not fit the same foot. What is stored is the chosen row AND a foot length:
   - same range as the pick: the chosen size, as chosen;
   - the other range: that range's row for the stored foot, and a line under the picker says so.
   The foot is the customer's own measurement when the size they selected is the one it matched;
   otherwise it is the MIDDLE of the chosen size's foot range (Andre, 2026-10-19: "Use the middle of
   the size's foot range"). All of it is in tenths of a centimetre as integers, the charts' own
   precision, so 22.4 + 0.1 never becomes 22.500000000000004.

   NEVER OVERRIDES: a ?variant= in the URL (a link that names a size, e.g. from the collection size
   finder), a size already chosen on the page, or a size that cannot be bought here. A size with no
   equivalent in this range (current range Women's 13.5 and up, on an original-range page) is left
   unselected.

   localStorage, like the Women's/Men's scale (snippets/pulse-size-scale.liquid): it lasts until the
   customer selects another size. Every access is guarded; private mode simply remembers nothing. */
(function () {
  if (window.PulseSizeMemory) return;

  var KEY = 'pulse-size-pick';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || 'null');
      return v && v.range && v.usm != null && typeof v.foot === 'number' ? v : null;
    } catch (e) { return null; }
  }
  function write(v) {
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode */ }
  }

  function tenths(x) {
    var n = parseFloat(x);
    return isNaN(n) ? null : Math.round(n * 10);
  }

  /* The chart rows for a [data-psg] root, as the blob Liquid printed them. */
  function chartOf(root) {
    var el = root && root.querySelector('[data-psg-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function rowsOf(chart, range) {
    var r = chart && chart[range];
    return Array.isArray(r) ? r : [];
  }

  /* The middle of a size's foot range. A row's `cm` is its MAXIMUM; its range starts 0.1 above the row
     before. The first row has no floor ("22.3 or less"), so it is treated as a half size of 0.5 cm,
     which is the reading the equivalents table shown to Andre was built on. */
  function middle(rows, usm) {
    for (var i = 0; i < rows.length; i++) {
      if (String(rows[i].usm) !== String(usm)) continue;
      var hi = tenths(rows[i].cm);
      if (hi === null) return null;
      var lo = i > 0 ? tenths(rows[i - 1].cm) + 1 : hi - 4;
      return (lo + hi) / 2;
    }
    return null;
  }

  /* The first row whose maximum holds the foot: the same rule the size finder matches on. */
  function rowForFoot(rows, foot) {
    for (var i = 0; i < rows.length; i++) {
      var hi = tenths(rows[i].cm);
      if (hi !== null && foot <= hi) return rows[i];
    }
    return null;
  }
  function rowForUsm(rows, usm) {
    for (var i = 0; i < rows.length; i++) if (String(rows[i].usm) === String(usm)) return rows[i];
    return null;
  }

  function rangeOf(root) {
    var on = root.querySelector('[data-psg-range].is-on');
    return (on && on.getAttribute('data-psg-range')) || root.getAttribute('data-default-range') || 'new';
  }

  /* The last measurement each finder matched, so a Select on that same size stores the real foot. */
  var measured = null;
  function listen(root) {
    root.addEventListener('psg:answer', function (e) {
      var d = e.detail || {};
      measured = d.state === 'match' && d.row && d.cm
        ? { range: rangeOf(root), usm: String(d.row.usm), foot: tenths(d.cm) }
        : null;
    });
  }

  function save(range, rows, usm, usw) {
    if (usm == null || !rows.length) return null;
    var foot = measured && measured.range === range && measured.usm === String(usm)
      ? measured.foot
      : middle(rows, usm);
    if (foot === null) return null;
    var v = { range: range, usm: String(usm), usw: String(usw), foot: foot, t: Date.now() };
    write(v);
    return v;
  }

  /* ---------- words ---------- */
  var i18n = null;
  function T() {
    if (i18n) return i18n;
    i18n = {};
    try {
      var el = document.querySelector('[data-pulse-size-i18n]');
      if (el) i18n = JSON.parse(el.textContent) || {};
    } catch (e) { i18n = {}; }
    return i18n;
  }
  function fill(tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (w, k) { return k in map ? map[k] : w; });
  }
  function men() {
    return !!(window.PulseSizeScale && window.PulseSizeScale.gender() === 'men');
  }
  /* ONE gendered size, never the variant triple: "Women's US 9.5". */
  function label(usw, usm) {
    var t = T();
    return men()
      ? fill(t.card_men || "Men's US [size]", { size: usm })
      : fill(t.card_women || "Women's US [size]", { size: usw });
  }

  /* ---------- saving ---------- */
  document.addEventListener('click', function (e) {
    /* The PDP drawer: a chart row's Select, or the answer card's, which carries the lit row's variant. */
    var pick = e.target.closest('[data-size-pick]');
    if (pick && !pick.disabled) {
      var root = pick.closest('[data-psg]');
      if (!root) return;
      var tr = pick.closest('tr[data-psg-row]') ||
        root.querySelector('tr[data-psg-row][data-variant-id="' + pick.getAttribute('data-size-pick') + '"]');
      if (!tr) return;
      var range = rangeOf(root);
      save(range, rowsOf(chartOf(root), range), tr.getAttribute('data-usm'), tr.getAttribute('data-usw'));
      /* They chose here, so the "matched from the other range" line no longer applies. */
      clearMemo();
      return;
    }

    /* The size guide page's answer card. */
    var btn = e.target.closest('[data-size-save]');
    if (btn && !btn.disabled) {
      var groot = btn.closest('[data-psg]') || document.querySelector('[data-psg]');
      var grange = btn.getAttribute('data-range') || 'new';
      var usw = btn.getAttribute('data-usw'), usm = btn.getAttribute('data-usm');
      if (!save(grange, rowsOf(chartOf(groot), grange), usm, usw)) return;
      /* a "Show me" link (2026-10-23) is on its way to the filtered collection: keep the size, let it go */
      if (btn.tagName === 'A') return;
      var done = document.createElement('p');
      done.className = 'pulse-sizememo pulse-sizememo--saved';
      done.setAttribute('role', 'status');
      done.textContent = fill(T().memo_saved || 'Saved. Product pages will now open in [size].', { size: label(usw, usm) });
      btn.replaceWith(done);
    }
  });

  /* ---------- applying ---------- */
  var memo = null;
  var memoFrom = null;
  function clearMemo() {
    if (memo && memo.parentNode) memo.parentNode.removeChild(memo);
    memo = null;
    memoFrom = null;
  }
  function paintMemo() {
    if (!memo || !memoFrom) return;
    var t = T();
    var rangeWords = memoFrom.range === 'original'
      ? (t.memo_range_original || 'our original range')
      : (t.memo_range_new || 'our current range');
    memo.textContent = fill(t.memo_matched || 'Matched to the [size] you chose in [range].', {
      size: label(memoFrom.usw, memoFrom.usm),
      range: rangeWords
    });
  }

  function apply() {
    var select = document.querySelector('[data-pulse-sizeselect]');
    var root = document.querySelector('pulse-size-drawer [data-psg]');
    if (!select || !root) return;
    if (/[?&]variant=/.test(location.search)) return;
    if (select.value) return;

    var mem = read();
    if (!mem) return;

    var range = root.getAttribute('data-default-range') || 'new';
    var rows = rowsOf(chartOf(root), range);
    var row = mem.range === range ? rowForUsm(rows, mem.usm) : rowForFoot(rows, mem.foot);
    if (!row) return;

    var tr = root.querySelector('[data-psg-table="' + range + '"] tr[data-psg-row][data-usm="' + row.usm + '"]');
    var id = tr && tr.getAttribute('data-available') === 'true' ? tr.getAttribute('data-variant-id') : '';
    if (!id) return;
    var opt = Array.prototype.find.call(select.options, function (o) { return o.value === id; });
    if (!opt || opt.disabled) return;

    select.value = id;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    if (mem.range !== range) {
      var box = select.closest('.pdp-sizeselect') || select;
      memo = document.createElement('p');
      memo.className = 'pulse-sizememo';
      memoFrom = mem;
      paintMemo();
      box.parentNode.insertBefore(memo, box.nextSibling);
      /* A size they pick themselves is theirs, not ours to explain. */
      select.addEventListener('change', function (ev) { if (ev.isTrusted) clearMemo(); });
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-psg]');
    for (var i = 0; i < roots.length; i++) listen(roots[i]);
    apply();
    if (window.PulseSizeScale) window.PulseSizeScale.onChange(paintMemo);
  }

  window.PulseSizeMemory = { read: read, middle: middle, rowForFoot: rowForFoot };

  /* Deferred scripts run before DOMContentLoaded, so the product page's own script has bound its
     change listener by the time this applies the size, whichever file ran first. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
